import { Check, Clock, X, type LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";
import type { NotificationType } from "@/features/notification/types";

/**
 * The leading status icon for a notification, keyed off its type: a clock for
 * "it's your turn", a green check for confirmed, a red cross for declined.
 */
const META: Record<
  NotificationType,
  { Icon: LucideIcon; wrap: string; fg: string }
> = {
  VIEWING_AWAITING_YOU: { Icon: Clock, wrap: "bg-primary/10", fg: "text-primary" },
  VIEWING_CONFIRMED: {
    Icon: Check,
    wrap: "bg-emerald-100",
    fg: "text-emerald-600",
  },
  VIEWING_DECLINED: { Icon: X, wrap: "bg-rose-100", fg: "text-rose-600" },
};

export function NotificationIcon({
  type,
  size = "md",
}: {
  type: NotificationType;
  size?: "sm" | "md";
}) {
  const meta = META[type] ?? META.VIEWING_AWAITING_YOU;
  const Icon = meta.Icon;
  return (
    <span
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full",
        size === "sm" ? "size-7" : "size-9",
        meta.wrap,
      )}
    >
      <Icon
        className={cn(size === "sm" ? "size-3.5" : "size-4", meta.fg)}
        aria-hidden="true"
      />
    </span>
  );
}
